import React from 'react';
import { Link } from 'gatsby';
import SbEditable from 'storyblok-react';
import renderLink from '~/utils/render-link';

import Image from '~/components/Dynamic/Image';
import IconLink from '~/components/IconLink';

export default function Grid2({ blok }) {
  if (!blok.gridItem[0].textCard.length) return null;
  const [item1, item2, item3] = blok?.gridItem;

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-28">
        <div className="container">
          <div className="flex flex-wrap -ml-5">
            <div className="flex flex-col w-full pl-5 mb-5 md:w-1/2 md:mb-0">
              {item1 && (
                <SbEditable content={item1} key={item1._uid}>
                  <Link
                   to={renderLink(item1?.textCard[0]?.button[0]?.button?.cached_url)}
                    className="relative flex flex-col flex-auto px-5 py-8 pt-10 overflow-hidden bg-lime md:px-8 group"
                  >
                    {item1.image && (
                      <div className="-ml-5 md:-ml-8">
                        <div style={{ width: 240 }}>
                          <Image blok={item1.image} className="max-w-[200px] mx-0 mr-auto md:max-w-none transform transition-transform group-hover:scale-105 duration-700" imageClassName="mr-auto" />
                        </div>
                      </div>
                    )}
                    <div className="flex flex-col items-start justify-end flex-auto mt-8">
                      <h3 className="text-h3">{item1.textCard[0]?.heading}</h3>
                      <p className="mt-2 mb-4 text-20px">{item1.textCard[0]?.content}</p>
                      <IconLink color={'black'} type="button" className="transition-opacity duration-200 group-hover:opacity-50">
                        {item1.textCard[0].button[0].title}
                      </IconLink>
                    </div>
                  </Link>
                </SbEditable>
              )}
            </div>
            <div className="flex flex-col w-full pl-5 md:w-1/2">
              {[item2, item3]
                .filter((i) => i)
                .map((item, i) => (
                  <SbEditable content={item} key={item._uid}>
                    <Link
                      key={`alt-item${i}`}
                      to={renderLink(item?.textCard[0]?.button[0]?.button?.cached_url) || '#'}
                      className={`relative flex flex-auto p-5 bg-light-grey group overflow-hidden md:p-8 ${i === 0 && 'mb-5'}`}
                    >
                      <div className="relative flex flex-col justify-between flex-1 mr-12 text-black font-heading">
                        <div>
                          <h3 className="mt-3 font-bold text-36px">{item.textCard[0]?.heading}</h3>
                          <p className="mb-3 text-17px">{item.textCard[0]?.content}</p>
                        </div>
                        <div className="mt-20">
                          <IconLink color={`black`} type="button" className="transition-opacity duration-200 group-hover:opacity-50">
                            {item.textCard[0]?.button[0]?.title}
                          </IconLink>
                        </div>
                      </div>

                      {item.image && (
                        <div
                          className={`flex flex-col items-end -mr-4 justify-end md:hidden lg:flex w-6/12 mt-auto ${i === 1 && '-mr-8 md:-mr-16'} `}>
                          <Image blok={item.image} className="transition-transform duration-700 transform group-hover:scale-105" imageClassName="object-contain w-full ml-auto max-h-[150px] max-w-[150px] md:max-w-[250px] md:max-h-[250px] -mr-4" />
                        </div>
                      )}
                    </Link>
                  </SbEditable>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
